/* Paddle Putty — Shopify theme behaviour
   Mobile nav, FAQ accordion, quantity steppers, toast. */
(function () {
  'use strict';

  // ---- Mobile nav toggle ----
  function initNav() {
    var toggle = document.getElementById('navToggle');
    var links = document.getElementById('navLinks');
    if (toggle && links) {
      toggle.addEventListener('click', function () {
        links.classList.toggle('is-open');
      });
    }
  }

  // ---- FAQ accordion ----
  function initFaq() {
    document.querySelectorAll('.faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        var answer = item.querySelector('.faq-a');
        var open = item.classList.toggle('is-open');
        answer.style.maxHeight = open ? answer.scrollHeight + 'px' : '0';
      });
    });
  }

  // ---- Quantity steppers (data-qty-wrap with [data-minus]/[data-plus] + input) ----
  function initQty() {
    document.querySelectorAll('[data-qty-wrap]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      var min = parseInt(input.getAttribute('data-min'), 10) || 1;
      var step = parseInt(input.getAttribute('data-step'), 10) || 1;
      var read = function () { return Math.max(min, parseInt(input.value, 10) || min); };
      var minus = wrap.querySelector('[data-minus]');
      var plus = wrap.querySelector('[data-plus]');
      if (minus) minus.addEventListener('click', function () { input.value = Math.max(min, read() - step); });
      if (plus) plus.addEventListener('click', function () { input.value = read() + step; });
      input.addEventListener('input', function () { input.value = input.value.replace(/[^0-9]/g, ''); });
      input.addEventListener('blur', function () { if ((parseInt(input.value, 10) || 0) < min) input.value = min; });
    });
  }

  // ---- Mobile autoplay fallback for muted demo videos ----
  function initAutoplayVideos() {
    var videos = Array.prototype.slice.call(document.querySelectorAll('[data-autoplay-video]'));
    if (!videos.length) return;

    function play(video) {
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(function () {
          video.controls = true;
        });
      }
    }

    videos.forEach(function (video) {
      play(video);
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) play(entry.target);
        });
      }, { threshold: 0.35 });
      videos.forEach(function (video) { observer.observe(video); });
    }

    window.addEventListener('touchstart', function () {
      videos.forEach(play);
    }, { once: true, passive: true });
  }

  // ---- Toast ----
  function toast(msg) {
    var t = document.getElementById('ppToast');
    if (!t) return;
    t.querySelector('.toast__msg').textContent = msg;
    t.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }
  window.PPToast = toast;

  // ---- Video popup (modal) ----
  function initVideoModal() {
    document.querySelectorAll('.video-modal').forEach(function (modal) {
      var player = modal.querySelector('video');
      function open() {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        if (player) { try { player.currentTime = 0; } catch (e) {} player.play().catch(function () {}); }
      }
      function close() {
        modal.hidden = true;
        document.body.style.overflow = '';
        if (player) { player.pause(); }
      }
      document.querySelectorAll('[data-video-open][aria-controls="' + modal.id + '"]').forEach(function (b) { b.addEventListener('click', open); });
      modal.querySelectorAll('[data-video-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    });
    var requestedVideo = new URLSearchParams(window.location.search).get('video');
    if (requestedVideo) {
      var requestedButton = Array.prototype.find.call(document.querySelectorAll('[data-video-open][data-video-slug]'), function (button) {
        return button.getAttribute('data-video-slug') === requestedVideo;
      });
      if (requestedButton) requestedButton.click();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initFaq();
    initQty();
    initAutoplayVideos();
    initVideoModal();
  });
})();
